// extracted by mini-css-extract-plugin
export var text = "_d-0";